module.exports = __webpack_public_path__ + "static/media/indian-institute.ffb5f6b4.svg";